import { Navigate, Route, Routes } from "react-router-dom";

import {
  BenefitTypeExpensesPage,

  ExpensesLayout,
  ExpensesOverviewPage,
  HealthPlanImportPage,
  HealthPlanImportsPage,
  HealthPlanImportDetailsPage,
  HealthPlanImportCollaboratorDetailsPage,
  FuneralAssistanceImportsPage,
  FuneralAssistanceImportPage,
  FuneralAssistanceImportDetailsPage,
  FoodBenefitImportsPage,
  FoodBenefitImportPage,
  FoodBenefitImportDetailsPage,
  PetPlanImportsPage,
  PetPlanImportPage,
  PetPlanImportDetailsPage,
  HealthPromotionImportsPage,
  HealthPromotionImportPage,
  HealthPromotionImportDetailsPage,
  PayrollExpensesPage,
  PayrollImportPage,
  PayrollImportDetailsPage,
  PayrollImportCollaboratorDetailsPage,
  ChargeCalculationsPage,
  ChargeCalculationDetailsPage,
} from "@/features/Expenses";
import { ROLE_COMBINATIONS } from "@/router/proxyRouter.definitions";
import { RoleBasedRoute } from "..";

export function ExpensesRoutes() {
  return (
    <Routes>
      <Route
        element={
          <RoleBasedRoute requiredRoles={ROLE_COMBINATIONS.ADMIN_ONLY}>
            <ExpensesLayout />
          </RoleBasedRoute>
        }
      >
        <Route index element={<ExpensesOverviewPage />} />
        <Route path="payroll" element={<PayrollExpensesPage />} />
        <Route path="payroll/:importId" element={<PayrollImportDetailsPage />} />
        <Route path="payroll/:importId/collaborator/:collaboratorId" element={<PayrollImportCollaboratorDetailsPage />} />
        <Route path="payroll/import" element={<PayrollImportPage />} />

        <Route path="charges" element={<ChargeCalculationsPage />} />
        <Route path="charges/:id" element={<ChargeCalculationDetailsPage />} />

        <Route path="benefits/health-plan" element={<HealthPlanImportsPage />} />
        <Route path="benefits/funeral-assistance" element={<FuneralAssistanceImportsPage />} />
        <Route path="benefits/funeral-assistance/import" element={<FuneralAssistanceImportPage />} />
        <Route path="benefits/funeral-assistance/imports/:competence" element={<FuneralAssistanceImportDetailsPage />} />
        <Route path="benefits/food" element={<FoodBenefitImportsPage />} />
        <Route path="benefits/food/import" element={<FoodBenefitImportPage />} />
        <Route path="benefits/food/imports/:competence" element={<FoodBenefitImportDetailsPage />} />
        <Route path="benefits/pet-plan" element={<PetPlanImportsPage />} />
        <Route path="benefits/pet-plan/import" element={<PetPlanImportPage />} />
        <Route path="benefits/pet-plan/imports/:competence" element={<PetPlanImportDetailsPage />} />
        <Route path="benefits/health-promotion" element={<HealthPromotionImportsPage />} />
        <Route path="benefits/health-promotion/import" element={<HealthPromotionImportPage />} />
        <Route path="benefits/health-promotion/imports/:competence" element={<HealthPromotionImportDetailsPage />} />
        <Route path="benefits/:benefitType" element={<BenefitTypeExpensesPage />} />
        <Route path="benefits/health-plan/import" element={<HealthPlanImportPage />} />
        <Route path="benefits/health-plan/imports/:competence" element={<HealthPlanImportDetailsPage />} />
        <Route path="health-plan/:importId/collaborator/:collaboratorId" element={<HealthPlanImportCollaboratorDetailsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/expenses" replace />} />
    </Routes>
  );
}
